import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let automations = useDataValue({
    context: 'automations',
    viewPath: props.viewPath,
  })
  // TODO: revisit this, it's used to create one automation
  let automation_id = null
  // let automation_id = useDataValue({
  //   context: 'connection',
  //   path: 'automation_id',
  //   viewPath: props.viewPath,
  // })

  return useMemo(() => {
    if (!automations) return data

    let steps = automations
      // only keep the missing automations
      .filter(automation => !automation.is_created)
      .map(automation => ({
        ...automation,
        step_type: 'automation',
        status: 'pending',
      }))

    if (automation_id) {
      return {
        steps: automations
          .filter(automation => automation.automation_id === automation_id)
          .map((step, index) => ({ ...step, index })),
        current_index: 0,
      }
    }

    return {
      steps: steps.map((step, index) => ({ ...step, index })),
      current_index: 0,
    }
  }, [automation_id, automations, data])
}
